import { CalendarView } from '../../Calendar'
import { Container } from '../Container'

function CalendarViews() {
  return (
    <Container label='Tasks calendar on the mock feed'>
      <CalendarView />
    </Container>
  )
}

export default CalendarViews
